/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Discussion from './Discussion/index'
import FeatureFlag from 'DesignSystem/FeatureFlag/react'
import InApp from './InApp/index'
import No from './No/index'
import Phone from './Phone/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Comms/Content/ContactMethods/Item"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let contactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'contact_method',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: contactMethodTypeValueData,
})
let globalCurrentLocationParentCompanyIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.id',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Phone'}>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
</fromFlow.When>
<FeatureFlag
  viewPath={`${viewPath}/FeatureFlag`}
 name="admin.patient.discussion.enabled"
 data="global.current_location.parent_company.id"
 organization_ids={globalCurrentLocationParentCompanyIdValueData}
 support={false}
>
{childProps => (
<fromFlow.When is={flowValue === 'Discussion'}>
<Discussion
{...childProps}
  viewPath={`${viewPath}/Discussion`}
/>
</fromFlow.When>
)}
</FeatureFlag>
{children}
</React.Fragment>)
}